import { t } from '@lingui/core/macro';
import { isPossiblePhoneNumber } from '@pocketlaw/tetris';
import { object, string } from 'yup';
export const getSchema = () => {
    const requiredMessage = t({
        message: 'This is a required field.',
        comment: 'Error message for empty required field',
    });
    const mobileErrorMessage = t({
        message: 'This must be a valid phone number.',
        comment: 'Error message for invalid phone number for e-signing party',
    });
    return object().shape({
        email: string()
            .required(requiredMessage)
            .test('valid-phone-number', mobileErrorMessage, (mobile = '') => isPossiblePhoneNumber(mobile)),
    });
};
